<template>
  <div class="dhlr-container">
    <!-- <van-icon name="cash-back-record" />  -->
    <div class="kkpje-con">
      <span class="kkpje-con-label">开票金额</span>
      <span class="money">{{ formData.JE }}</span>
    </div>

    <van-form @submit="onSubmit">
      <!-- //发票类型    -->
      <van-field name="radio" label="抬头类型" :disabled="formData.XGBZ === '0'">
        <template #input>
          <van-radio-group @change="changeTtlx" icon-size="15px" checked-color="#ff6d00" v-model="formData.FPZL" direction="horizontal">
            <van-radio name="021">数电普票</van-radio>
            <van-radio name="020">数电专票</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- //抬头类型    -->
      <van-field name="radio" label="抬头类型" :disabled="formData.XGBZ === '0'">
        <template #input>
          <van-radio-group @change="changeTtlx" icon-size="15px" checked-color="#ff6d00" v-model="tglx" direction="horizontal">
            <van-radio :disabled="formData.XGBZ === '0'" name="1">企业</van-radio>
            <van-radio :disabled="formData.XGBZ === '0'" name="2" v-if="formData.FPZL != '020'">个人、事业单位</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <!-- //企业抬头 -->
      <div style="position: relative" v-if="tglx === '1'">
        <div v-if="formData.XGBZ !== '0'" @click="getWxInv" class="wx-info-btn">
          <van-icon name="pending-payment" />
        </div>
        <div class="qymc-box" style="">
          <span class="qymc-label" :style="{ color: formData.XGBZ === '0' ? '#c8c9cc' : '#646566' }"> <i style="color: #f00">*</i> 企业名称</span>
          <el-autocomplete v-model="formData.KHMC" :fetch-suggestions="querySearchAsync" :disabled="formData.XGBZ === '0'" placeholder="请输入企业名称" @select="handleSelect" class="qymc"></el-autocomplete>
        </div>

        <van-field v-model="formData.KHSH" name="KHSH" required :disabled="formData.XGBZ === '0'" label="企业税号" placeholder="请输入企业税号" :rules="[{ required: true, message: '' }]" />

        <van-collapse v-model="activeNames">
          <van-collapse-item title="更多" name="1">
            <van-field v-model="formData.QYDZ" name="QYDZ" label="企业地址" :required="formData.FPZL === '004'" placeholder="请输入地址" :rules="formData.FPZL === '004' ? [{ required: true, message: '' }] : []" :disabled="formData.XGBZ === '0'" />
            <van-field v-model="formData.QYDH" name="QYDH" label="企业电话" :required="formData.FPZL === '004'" placeholder="请输入电话" :rules="formData.FPZL === '004' ? [{ required: true, message: '' }] : []" :disabled="formData.XGBZ === '0'" />
            <van-field v-model="formData.KHYH" name="KHYH" label="开户银行" :required="formData.FPZL === '004'" placeholder="请输入开户银行" :rules="formData.FPZL === '004' ? [{ required: true, message: '' }] : []" :disabled="formData.XGBZ === '0'" />
            <van-field v-model="formData.YHZH" name="YHZH" label="银行账户" :required="formData.FPZL === '004'" placeholder="请输入银行账户" :rules="formData.FPZL === '004' ? [{ required: true, message: '' }] : []" :disabled="formData.XGBZ === '0'" />
            <!-- <van-field v-model="formData.BZ" name="BZ" label="备注" type="textarea" placeholder="请输入备注" rows="3" autosize show-word-limit :disabled="formData.XGBZ === '0'" /> -->
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- //个人类型抬头 -->
      <div style="position: relative" v-if="tglx === '2'">
        <div v-if="formData.XGBZ !== '0'" @click="getWxInv" class="wx-info-btn">
          <van-icon name="pending-payment" />
        </div>
        <van-field v-model="formData.KHMC" name="发票抬头" required :disabled="formData.XGBZ === '0'" label="发票抬头" placeholder="请输入发票抬头" :rules="[{ required: true, message: '' }]" />

        <van-collapse v-model="activeNames">
          <van-collapse-item title="更多" name="1">
            <!-- <van-field v-model="formData.BZ" name="BZ" label="备注" type="textarea" placeholder="请输入备注" rows="3" autosize show-word-limit :disabled="formData.XGBZ === '0'" /> -->
            <van-field v-model="formData.KHSH" name="KHSH" :disabled="formData.XGBZ === '0'" label="证件号/税号" placeholder="请输入证件号/税号" />
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="spfs" style="">收票方式 :</div>
      <!-- //收票方式-电子邮箱 -->
      <div>
        <van-field v-model="formData.KHSJ" name="KHSJ" label="手机号码" placeholder="请输入手机号码" />
        <van-field v-model="formData.KHYJ" name="电子邮箱" required label="电子邮箱" srequired placeholder="请输入接收发票的电子邮箱" :rules="[{ required: true, message: '' }]" />
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import Vue from "vue";
import { Form } from "vant";
import { Field } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { Toast } from "vant";
import { Button } from "vant";
import { Area } from "vant";
import { Popup } from "vant";
import { Picker } from "vant";

import { Collapse, CollapseItem } from "vant";

Vue.use(Collapse).use(CollapseItem);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Form);
Vue.use(Field);
// import $ from "jquery";
import { mapState } from "vuex";

import { wxConfig } from "@/utils";

export default {
  computed: {
    ...mapState(["dhInfo", "fpInfo", "InvoiceInfo", "FPZL"]),
  },
  data() {
    return {
      fpzl: {
        "004": "纸质专票",
        "007": "纸质普票",
        "020": "全电专票",
        "021": "全电普票",
        "026": "电子普票",
        "028": "电子专票",
      }, // 发票总类
      columns: [], //发票种类列表
      noFpzl: false,
      indexDQ: "",
      indexValue: "",
      areaList,
      type: "",
      tglx: "1",
      SJR: "",
      SJDZ: "",
      SJRDH: "",
      formData: {
        FPZL: "021",

        JE: localStorage.getItem("totalPrice") || "",
        KHMC: "",
        KHSH: "",
        KHDZ: "", // 客户地址电话
        KHSJ: "",
        KHYJ: "",
        KTDZ: "",
        SJR: "",
        QYDZ: "", // 企业地址
        QYDH: "", // 企业电话
        KHYH: "",
        YHZH: "", // 开户银行
        BZ: "",
      },
      postData: null,

      state: "",
      timeout: null,

      activeNames: [], // 更多折叠
      more: false,

      uid: localStorage.getItem("uid") || "",
      orderid: localStorage.getItem("orderIds") || "",
      price: localStorage.getItem("totalPrice") || "",
    };
  },
  created() {
    wxConfig();
    const querys = this.$route.query;
    console.log("querys", querys);
    if (querys.uid) this.uid = querys.uid;
    if (querys.orderid) this.orderid = querys.orderid;
    if (querys.price) this.formData.JE = querys.price;
    if (!this.uid) {
      Toast("无用户信息");
      return;
    }
    if (this.formData.JE == 0) {
      Toast("0金额不支持开票");
      this.$router.push({ path: "/orderList", query: { uid: this.uid } });
      return;
    }
    if (!this.orderid || !this.formData.JE) {
      Toast("请先选择订单");
      this.$router.push({ path: "/orderList", query: { uid: this.uid } });
      return;
    }
  },
  methods: {
    formD(obj) {
      const formData = new URLSearchParams();
      Object.keys(obj).forEach((key) => {
        if (obj[key] instanceof Array) {
          obj[key].forEach((item) => {
            formData.append(key, item);
          });
          return;
        }
        formData.append(key, obj[key]);
      });
      return formData;
    },
    // 切换抬头类型
    changeTtlx(ttlx) {
      //判断是否个人名称，个人名称清空
      if (ttlx == "1" && this.formData.KHMC == "个人") {
        console.error("检测到个人名称，删除");
        this.formData.KHMC = "";
      }
      if (ttlx == "2") {
        this.formData.KHSH = "";
      }
    },
    // 提交发票
    async onSubmit() {
      if (!this.formData.KHMC) return Toast("企业名称不能为空");

      try {
        let data = {
          uid: this.uid,
          dh: this.orderid.split(","),
          khmc: this.formData.KHMC || "",
          khsh: this.formData.KHSH || "",
          khdz: `${this.formData.QYDZ} ${this.formData.QYDH}`,
          khyh: `${this.formData.KHYH} ${this.formData.YHZH}`,
          khyj: this.formData.KHYJ || "",
          fpzl: this.formData.FPZL || "",
          sjh: this.formData.KHSJ || "",
        };
        // Object.keys(this.formData).forEach((item) => {
        //   //解决值为null的问题
        //   if (this.formData[item] == undefined || this.formData[item] == null) {
        //     data[item.toLowerCase()] = "";
        //   } else {
        //     data[item.toLowerCase()] = this.formData[item];
        //   }
        // });
        const wxshRes = await this.$axios.post("/api/Invoice/CreateInvoice", data);
        if (wxshRes.Result == "1") {
          Toast(wxshRes.Message || "提交成功");
          data.je = this.formData.JE;
          localStorage.setItem("kpwcInfo", JSON.stringify(data));
          this.$router.push({ path: "/kpwc" });
        } else {
          Toast(wxshRes.Message || "提交失败");
        }
      } catch (err) {
        console.log("err", err);
        Toast("操作异常");
      }
    },
    // 获取微信抬头信息
    getWxInv() {
      window.wx.invoke(
        "chooseInvoiceTitle",
        {
          scene: 1,
        },
        (res) => {
          console.log("获取微信抬头信息", res);
          if (!res.choose_invoice_title_info) return;

          try {
            let str = JSON.stringify(res.choose_invoice_title_info);
            while (str.indexOf("\\") >= 0) str = str.replace("\\", "");
            str = str.substr(1, str.length - 2);
            let s = eval("(" + str + ")");
            this.formData.KHMC = s.title;
            this.formData.KHSH = s.taxNumber;
            this.formData.KHSJ = s.telephone;
            // this.formData.KHYH=s.bankName+''+s.bankAccount
            // this.formData.KHDZ=s.companyAddress
            this.formData.QYDZ = s.companyAddress; //企业地址
            this.formData.QYDH = s.telephone; //企业电话

            this.formData.KHYH = s.bankName; //开户银行
            this.formData.YHZH = s.bankAccount; //银行账号
          } catch (e) {
            console.log(e);
          }
        },
      );
    },

    // 智能抬头
    querySearchAsync(khmc, cb) {
      if (!khmc || khmc.length < 4) {
        cb([]);
        return;
      }
      this.$axios
        .post(
          window.urlHead + "/newkp/JCZL/ZNKHZL",
          this.$formD({
            khmc: khmc,
            token: localStorage.getItem("token"),
          }),
        )
        .then((res) => {
          if (res.Result == "1" && res.KHZLList.length > 0) {
            res.KHZLList.forEach((item) => {
              item.value = item.clientName;
            });
            cb(res.KHZLList);
          } else {
            cb([]);
          }
        })
        .catch(() => {
          cb([]);
        });
    },
    handleSelect(item) {
      console.log(item);
      this.$axios
        .post(
          window.urlHead + "/newkp/JCZL/KHXQ",
          this.$formD({
            code: item.taxNo,
            token: localStorage.getItem("token"),
          }),
        )
        .then((res) => {
          if (res.Result == "1") {
            this.formData.KHSH = res?.taxNo;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url(./index.less);
</style>
